import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "reactstrap";
import * as url from "../../utils/urls";
import { apiReq } from "../../utils/utils";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Swal from "sweetalert2";
import Loading from "../../components/Common/Loading";

function Terms(props) {
  const [isEmpty, setIsEmpty] = useState(false);
  const [content, setContent] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm();
  const allFields = watch();
  const user = useSelector((state) => state.User);

  useEffect(() => {
    if (user?.user?.role?.title !== "Admin") {
      props.history.push("/dashboard");
    }
  }, []);

  // console.log("user", user);

  // get faqs
  const getPrivacy = () => {
    setIsLoading(true);
    apiReq(url.GET_TERMS, {}, "get", null)
      .then((res) => {
        if (res.success && res.data !== null) {
          setValue("title", res.data.title);
          setContent(res.data.content);
          setValue("meta_title", res.data.meta_title);
          setValue("meta_description", res.data.meta_description);
          setIsEmpty(false);
          setIsLoading(false);
        } else {
          setIsLoading(false);
          setIsEmpty(true);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("err>>>", err);
      });
  };

  useEffect(() => {
    getPrivacy();
  }, []);

  console.log("isEmpty", isEmpty);

  // Todo: Create privacy page first time
  const createPrivacy = (data) => {
    if (isEmpty) {
      setIsLoading(true);
      apiReq(
        url.CREATE_TERMS,
        {
          title: data.title,
          content: content,
          meta_title: data.meta_title,
          meta_description: data.meta_description,
        },
        "post",
        {
          Authorization: `Bearer ${user.user?.token}`,
        }
      )
        .then((res) => {
          setIsEmpty(false);
          setIsLoading(false);
          Swal.fire({
            title: "Success",
            text: res.message,
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
          // console.log("res>>>", res);
        })
        .catch((err) => {
          setIsLoading(false);
          console.log("err>>>", err);
        });
    } else {
      setIsLoading(true);
      apiReq(
        url.UPDATE_TERMS,
        {
          title: data.title,
          content: content,
          meta_title: data.meta_title,
          meta_description: data.meta_description,
        },
        "put",
        {
          Authorization: `Bearer ${user.user?.token}`,
        }
      )
        .then((res) => {
          setIsEmpty(false);
          setIsLoading(false);
          Swal.fire({
            title: "Success",
            text: res.message,
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
          // console.log("res>>>", res);
        })
        .catch((err) => {
          setIsLoading(false);
          console.log("err>>>", err);
        });
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        {isLoading && <Loading />}
        <Container fluid>
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">Data Security Policy</h5>
              <hr />
              <form onSubmit={handleSubmit(createPrivacy)}>
                <div className="mt-4">
                  <div className="mb-3">
                    <label>Heading(H1)</label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("title", { required: true })}
                      placeholder="Enter title"
                    />
                    {errors.title && (
                      <span className="text-danger">Title is required</span>
                    )}
                  </div>
                  <div className="mb-3 privacy_editor">
                    <label>Content</label>
                    <CKEditor
                      editor={ClassicEditor}
                      data={content}
                      style={{ minHeight: "130px" }}
                      onReady={(editor) => {
                        // You can store the "editor" and use when it is needed.
                        console.log("Editor is ready to use!", editor);
                      }}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        setContent(data);
                        // console.log({ event, editor, data });
                      }}
                      onBlur={(event, editor) => {
                        console.log("Blur.", editor);
                      }}
                      onFocus={(event, editor) => {
                        console.log("Focus.", editor);
                      }}
                    />
                  </div>
                </div>
                <h5 className="mt-4">SEO Meta Tags</h5>
                <hr />
                <div className="mb-3">
                  <label>
                    Meta Title{" "}
                    <small className="text-muted" style={{ opacity: 0.5 }}>
                      ({allFields?.meta_title?.length} / 70)
                    </small>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    {...register("meta_title", { required: false })}
                    placeholder="Enter title"
                  />
                </div>
                <div className="mb-3">
                  <label>
                    Meta Description{" "}
                    <small className="text-muted" style={{ opacity: 0.5 }}>
                      ({allFields?.meta_description?.length} / 200)
                    </small>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    {...register("meta_description", { required: false })}
                    placeholder="Enter description"
                  />
                </div>
                <hr />
                <div>
                  <button className="btn btn-primary" type="submit">
                    Save changes
                  </button>
                </div>
              </form>
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default Terms;
